webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(44);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(169);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(131);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(48);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(45);
	
	var _vClickOutside = __webpack_require__(130);
	
	var _vClickOutside2 = _interopRequireDefault(_vClickOutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vClickOutside2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes.routes,
	  mode: 'history'
	});
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  router: router,
	  store: _store2.default
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjUgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU0ICg3NjQ4MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+Jmx0Oy0tPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICAgICAgPGcgaWQ9Im1vYmlsZS1zdWItYWJvdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMi4wMDAwMDAsIC05MC4wMDAwMDApIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJhYm91dCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDY1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9InRvcC1zcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IiZsdDstLSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuMDAwMDAwLCAyNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoIiBwb2ludHM9IjguNjM4Nzk1ODMgMCAwIDguNjM4Nzk1ODMgOC42Mzg3OTU4MyAxNy4yNzc1OTE3Ij48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC4zMDQ4ODUwNTgsOC42Mzg3OTU4MyBMMjIuMDk3MjE1OCw4LjYzODc5NTgzIiBpZD0iUGF0aC0yIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports.scrubMixin = scrubMixin;
	
	function scrubMixin() {
	  return {
	    methods: {
	      scrub: function scrub(slug) {
	        return encodeURIComponent(slug);
	      }
	    }
	  };
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(72);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(73);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_REQUEST_SIZE = 1000;
	
	function escapeCategory(cat) {
	  if (!cat) {
	    return cat;
	  }
	  return encodeURIComponent(cat).replace(/%20/g, '\\%20');
	}
	
	var ProtocolsDB = function () {
	  function ProtocolsDB() {
	    (0, _classCallCheck3.default)(this, ProtocolsDB);
	
	    this.baseUrl = 'https://search-protocol-library-vtnb4isrcwl533qbttgesbtmny.us-west-2.es.amazonaws.com/';
	    this.protocolsIndexUrl = this.baseUrl + _util2.default.appendBranchSuffix('protocols') + '/protocol/';
	    this.protocolsIndexSearchUrl = this.baseUrl + _util2.default.appendBranchSuffix('protocols') + '/protocol/_search/';
	    this.categoriesIndexUrl = this.baseUrl + _util2.default.appendBranchSuffix('categories') + '/category/';
	  }
	
	  (0, _createClass3.default)(ProtocolsDB, [{
	    key: 'getCategories',
	    value: function getCategories() {
	      return _vue2.default.http.get(this.categoriesIndexUrl + '0').then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getFeaturedProtocols',
	    value: function getFeaturedProtocols() {
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl, { params: { q: 'flags.feature:true' } }).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }, {
	    key: 'queryProtocols',
	    value: function queryProtocols(query) {
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl, { params: { q: query, size: MAX_REQUEST_SIZE } }).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }, {
	    key: 'getProtocol',
	    value: function getProtocol(protocolSlug) {
	      return _vue2.default.http.get(this.protocolsIndexUrl + protocolSlug).then(function (response) {
	        return response.data._source;
	      });
	    }
	  }, {
	    key: 'getProtocolsByCategory',
	    value: function getProtocolsByCategory(rawCategory, rawSubCategory) {
	      var query = null;
	      var category = escapeCategory(rawCategory);
	      var subCategory = escapeCategory(rawSubCategory);
	
	      if (category && subCategory) {
	        query = '(categories.' + category + ':"' + subCategory + '")';
	      } else if (category) {
	        query = '(categories.' + category + ')';
	      } else {
	        console.error('Must provide category (and optionally) subcategory argument');
	        query = '*';
	      }
	
	      return _vue2.default.http.get(this.protocolsIndexSearchUrl + ('?q=' + query + '&size=' + MAX_REQUEST_SIZE)).then(function (response) {
	        return response.data.hits.hits;
	      });
	    }
	  }]);
	  return ProtocolsDB;
	}();
	
	exports.default = new ProtocolsDB();

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var branchName = ("protocol-delivery");
	var branchSuffix = function branchSuffix(name) {
	  return name === 'master' ? '' : '-' + name;
	};
	var appendBranchSuffix = function appendBranchSuffix(name) {
	  return encodeURIComponent(name + branchSuffix(("protocol-delivery")));
	};
	
	var createIframeListener = function createIframeListener(iframeId) {
	  return window.addEventListener('message', function (e) {
	    var origin = e.origin || e.originalEvent.origin;
	
	    console.log('parent received message!:  ', e.data.type, { data: e.data, origin: origin, e: e });
	
	    var iframe = document.getElementById(iframeId);
	    if (iframe === null) {
	      console.log('No iframe found with id', iframeId);
	    } else {
	      if (e.data.type === 'SCROLL_TO_TOP') {
	        var iframeYPos = document.getElementById('embedded-app').getBoundingClientRect().top;
	        var navHeight = document.getElementById('nav').offsetHeight;
	        window.scrollTo(0, iframeYPos + window.pageYOffset - navHeight);
	      }
	    }
	  }, false);
	};
	
	exports.default = {
	  branchSuffix: branchSuffix,
	  appendBranchSuffix: appendBranchSuffix,
	  branchName: branchName,
	  createIframeListener: createIframeListener
	};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(158),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_CATEGORIES = exports.UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
	var UPDATE_PROTOCOLS = exports.UPDATE_PROTOCOLS = 'UPDATE_PROTOCOLS';
	var SELECT_PROTOCOL = exports.SELECT_PROTOCOL = 'SELECT_PROTOCOL';

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(159),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _LandingView = __webpack_require__(138);
	
	var _LandingView2 = _interopRequireDefault(_LandingView);
	
	var _ResultsView = __webpack_require__(145);
	
	var _ResultsView2 = _interopRequireDefault(_ResultsView);
	
	var _ProtocolView = __webpack_require__(143);
	
	var _ProtocolView2 = _interopRequireDefault(_ProtocolView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = [{ path: '/', name: 'home', component: _LandingView2.default }, { path: '/categories/:category/:subCategory?', name: 'category-query', component: _ResultsView2.default }, { path: '/search/', name: 'search-query', component: _ResultsView2.default }, { path: '/protocol/:slug', name: 'protocol', component: _ProtocolView2.default }];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(44);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _mutationTypes = __webpack_require__(28);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _db = __webpack_require__(10);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var actions = {
	  initCategories: function initCategories(_ref) {
	    var commit = _ref.commit;
	
	    _db2.default.getCategories().then(function (response) {
	      var categories = response._source;
	      commit(types.UPDATE_CATEGORIES, { categories: categories });
	    });
	  },
	  queryProtocols: function queryProtocols(_ref2, query) {
	    var commit = _ref2.commit;
	
	    var params = { params: { q: query } };
	    console.log(params);
	    _db2.default.queryProtocols(params).then(function (response) {
	      var protocols = response.hits.hits;
	      commit(types.UPDATE_PROTOCOLS, { protocols: protocols });
	    });
	  }
	};
	
	var getters = {
	  categories: function categories(state) {
	    return state.categories;
	  }
	};
	
	exports.default = {
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(31);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(28);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  categories: [],
	  protocols: [],
	  protocol: {}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.UPDATE_CATEGORIES, function (state, payload) {
	  state.categories = payload.categories;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_PROTOCOLS, function (state, payload) {
	  state.protocols = payload.protocols;
	}), (0, _defineProperty3.default)(_mutations, types.SELECT_PROTOCOL, function (state, payload) {
	  state.protocol = payload.data;
	}), _mutations);
	
	exports.default = {
	  mutations: mutations,
	  state: state
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(170);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(47);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(46);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var mutations = _mutations2.default.mutations,
	    state = _mutations2.default.state;
	var actions = _actions2.default.actions,
	    getters = _actions2.default.getters;
	exports.default = new _vuex2.default.Store({
	  state: state,
	  actions: actions,
	  getters: getters,
	  mutations: mutations
	});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navigation = __webpack_require__(139);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _DeprecationBanner = __webpack_require__(134);
	
	var _DeprecationBanner2 = _interopRequireDefault(_DeprecationBanner);
	
	var _SearchBar = __webpack_require__(146);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _SiteFooter = __webpack_require__(148);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Navigation: _Navigation2.default,
	    SearchBar: _SearchBar2.default,
	    DeprecationBanner: _DeprecationBanner2.default,
	    SiteFooter: _SiteFooter2.default
	  },
	  beforeCreate: function beforeCreate() {
	    this.$store.dispatch('initCategories');
	  }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(68);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _entries = __webpack_require__(70);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Breadcrumb',
	  props: ['categories', 'protocol'],
	  methods: {
	    getProtocolCategories: function getProtocolCategories(protocol) {
	      var first = (0, _entries2.default)(protocol['categories'])[0];
	      var category = first[0];
	      var subCategory = first[1][0];
	      return [category, subCategory].filter(function (o) {
	        return o;
	      });
	    }
	  },
	  computed: {
	    myCategories: function myCategories() {
	      var c = (this.categories || []).filter(function (o) {
	        return o;
	      });
	      return c.length > 0 ? c : this.getProtocolCategories(this.protocol);
	    },
	    links: function links() {
	      var names = this.myCategories;
	      var url = '/categories/';
	      var res = [{ url: '/', name: 'Protocol Library' }];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(names), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var name = _step.value;
	
	          url += encodeURIComponent(name) + '/';
	          res.push({ url: url, name: name });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return res;
	    }
	  }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CalloutDocs',
	  methods: {
	    openChat: function openChat() {
	      Intercom('showNewMessage', 'I would like to inquire about custom protocols');
	    }
	  }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(11);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mixins = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Categories',
	  mixins: [(0, _mixins.scrubMixin)()],
	  methods: {
	    categories: function categories() {
	      return (0, _keys2.default)(this.$store.getters.categories).sort();
	    },
	    subCategories: function subCategories(category) {
	      return this.$store.getters.categories[category];
	    }
	  }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Container',
	  props: ['placeable'],
	  data: function data() {
	    return {
	      show: false,
	      img: this.placeable.type + '.png'
	    };
	  },
	
	  methods: {
	    containerImg: function containerImg() {
	      var type = this.placeable.type;
	      var url = 'https://s3.amazonaws.com/opentrons-images/website/labware/';
	      if (type.includes('96')) {
	        return url + '96-plate.png';
	      }
	      return url + type + '.png';
	    },
	    addDefaultSrc: function addDefaultSrc(e) {
	      e.target.src = 'https://s3.amazonaws.com/opentrons-images/website/labware/custom.png';
	    }
	  }
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iframeResizer = __webpack_require__(121);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ProtocolView',
	  props: ['src'],
	  mounted: function mounted() {
	    (0, _iframeResizer.iframeResizer)({
	      log: ("production") === 'development',
	      checkOrigin: false }, '#embedded-app');
	
	    _util2.default.createIframeListener('embedded-app');
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Error404Page'
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(26);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FeaturedProtocol',
	  props: ['protocol'],
	  methods: {
	    makeHtml: function makeHtml(markdownText) {
	      return new _showdown2.default.Converter().makeHtml(markdownText);
	    },
	    info: function info(key) {
	      return this.protocol._source[key];
	    },
	    hasContent: function hasContent(key) {
	      return this.protocol._source[key] !== '';
	    }
	  }
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Categories = __webpack_require__(27);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _FeaturedProtocol = __webpack_require__(137);
	
	var _FeaturedProtocol2 = _interopRequireDefault(_FeaturedProtocol);
	
	var _RecentlyAdded = __webpack_require__(144);
	
	var _RecentlyAdded2 = _interopRequireDefault(_RecentlyAdded);
	
	var _CalloutDocs = __webpack_require__(43);
	
	var _CalloutDocs2 = _interopRequireDefault(_CalloutDocs);
	
	var _db = __webpack_require__(10);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LandingView',
	  components: {
	    Categories: _Categories2.default,
	    FeaturedProtocol: _FeaturedProtocol2.default,
	    RecentlyAdded: _RecentlyAdded2.default,
	    CalloutDocs: _CalloutDocs2.default
	  },
	  data: function data() {
	    return {
	      featuredProtocols: []
	    };
	  },
	  created: function created() {
	    this.fetchFeaturedProtocols();
	  },
	
	  watch: {
	    '$route': 'fetchFeaturedProtocols'
	  },
	  methods: {
	    fetchFeaturedProtocols: function fetchFeaturedProtocols() {
	      var that = this;
	      _db2.default.getFeaturedProtocols().then(function (protocols) {
	        that.featuredProtocols = protocols;
	      });
	    }
	  }
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(11);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Navigation',
	  data: function data() {
	    return {
	      nav: {
	        about: false,
	        products: false,
	        applications: false,
	        protocols: false,
	        sns: false
	      },
	      mobileNav: {
	        about: false,
	        products: false,
	        applications: false,
	        protocols: false,
	        sns: false
	      },
	      active: {
	        about: false,
	        products: false,
	        applications: false,
	        protocols: false,
	        sns: false
	      },
	      menu: false,
	      request: null,
	      protocolModal: false,
	      open: false
	    };
	  },
	
	  methods: {
	    toggleMenu: function toggleMenu(menu) {
	      var _this = this;
	
	      (0, _keys2.default)(this.nav).forEach(function (key) {
	        if (_this.nav[key] !== _this.nav[menu]) {
	          _this.nav[key] = false;
	        }
	      });
	      this.nav[menu] = !this.nav[menu];
	      window.addEventListener('scroll', this.close);
	    },
	    isActive: function isActive(a) {
	      var _this2 = this;
	
	      var element = document.querySelector('#' + a);
	      (0, _keys2.default)(this.active).forEach(function (key) {
	        _this2.active[key] = true;
	      });
	      this.active[a] = !this.active[a];
	      if (!element.classList.contains('visible')) {
	        (0, _keys2.default)(this.active).forEach(function (key) {
	          _this2.active[key] = false;
	        });
	      }
	    },
	    openModal: function openModal(request) {
	      this.protocolModal = true;
	      this.request = request;
	      if (!document.body.contains('mobile-scrolling')) {
	        document.body.classList += 'mobile-scrolling';
	      }
	    },
	    toggleOpen: function toggleOpen() {
	      var _this3 = this;
	
	      this.open = !this.open;
	      this.menu = false;
	      (0, _keys2.default)(this.mobileNav).forEach(function (key) {
	        _this3.mobileNav[key] = false;
	      });
	      window.removeEventListener('scroll', this.close);
	      if (document.body.classList.contains('mobile-scrolling')) {
	        document.body.classList.remove('mobile-scrolling');
	      } else {
	        document.body.classList.add('mobile-scrolling');
	      }
	    },
	    close: function close() {
	      var _this4 = this;
	
	      this.menu = false;
	      this.open = false;
	      document.body.classList.remove('mobile-scrolling');
	      (0, _keys2.default)(this.nav).forEach(function (key) {
	        _this4.nav[key] = false;
	      });
	      (0, _keys2.default)(this.mobileNav).forEach(function (key) {
	        _this4.mobileNav[key] = false;
	      });
	      (0, _keys2.default)(this.active).forEach(function (key) {
	        _this4.active[key] = false;
	      });
	      window.removeEventListener('scroll', this.close);
	    },
	    showMenu: function showMenu(menu) {
	      this.mobileNav[menu] = !this.mobileNav[menu];
	      if (this.mobileNav[menu] === true) {
	        this.menu = true;
	      }
	    },
	    closeMenu: function closeMenu() {
	      var _this5 = this;
	
	      this.menu = false;
	      (0, _keys2.default)(this.mobileNav).forEach(function (key) {
	        _this5.mobileNav[key] = false;
	      });
	    },
	    closeOutside: function closeOutside() {
	      if (window.innerWidth >= 1024) this.close();
	    }
	  }
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(29);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _values = __webpack_require__(71);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParameterizeAndDownload',
	  props: ['downloadUrl', 'protocolParameters', 'protocolSlug', 'robotTab'],
	  data: function data() {
	    return {
	      files: {}
	    };
	  },
	  methods: {
	    updateFile: function updateFile(e, fieldName) {
	      var _this = this;
	
	      var reader = new window.FileReader();
	
	      reader.onload = function (f) {
	        var fileContents = f.target.result;
	        _this.$set(_this.files, fieldName, fileContents);
	      };
	      reader.readAsText(e.target.files[0]);
	    }
	  },
	  computed: {
	    specialFieldsKey: function specialFieldsKey() {
	      if (!this.protocolParameters) {
	        console.warn('No protocol parameters');
	      }
	      var fields = (0, _values2.default)(this.protocolParameters) || [];
	      return (0, _stringify2.default)(fields);
	    },
	    subdomain: function subdomain() {
	      var subdomain = window.location.href.split('://')[1].split('.')[0];
	
	      return subdomain === 'protocols' ? 'master' : subdomain;
	    },
	    fullDownloadUrl: function fullDownloadUrl() {
	      return this.downloadUrl;
	    },
	    protocolFields: function protocolFields() {
	      if (!this.protocolParameters) {
	        return;
	      }
	
	      return this.protocolParameters.map(function (param) {
	        var pythonType = param.annotation && param.annotation.type;
	
	        if (['StringSelection'].includes(pythonType)) {
	          return {
	            htmlElem: 'select',
	            name: param.name,
	            default: param.default,
	            options: param.annotation.options
	          };
	        }
	
	        var stepVals = { int: '1', float: 'any' };
	
	        var inputTypes = {
	          int: 'number',
	          float: 'text',
	          FileInput: 'file'
	        };
	
	        return {
	          htmlElem: 'input',
	          isFile: pythonType === 'FileInput',
	          name: param.name,
	          default: param.default,
	          type: inputTypes[pythonType],
	          step: stepVals[param.annotation]
	        };
	      });
	    }
	  }
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(26);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Protocol',
	  props: ['protocol', 'headers'],
	  data: function data() {
	    return {
	      markdown: this.protocol.markdown
	    };
	  },
	
	  computed: {
	    content: function content() {
	      var _this = this;
	
	      return this.headers.filter(function (header) {
	        return header[0] in _this.markdown && !!_this.markdown[header[0]];
	      }).map(function (item) {
	        var key = item[0];
	        var header = item[1];
	        return {
	          key: key,
	          header: header,
	          content: _this.makeHtml(_this.markdown[key])
	        };
	      });
	    }
	  },
	  methods: {
	    makeHtml: function makeHtml(markdown) {
	      return new _showdown2.default.Converter().makeHtml(markdown);
	    },
	    hasContent: function hasContent(item) {
	      return item.content !== '';
	    }
	  }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mixins = __webpack_require__(9);
	
	exports.default = {
	  name: 'ProtocolPreview',
	  mixins: [(0, _mixins.scrubMixin)()],
	  props: ['protocol'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    link: function link() {
	      return {
	        name: 'protocol',
	        params: {
	          slug: this.protocol._source.slug
	        }
	      };
	    }
	  },
	  methods: {
	    info: function info(protocol, key) {
	      return protocol._source[key];
	    }
	  }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(29);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(31);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(74);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _Breadcrumb = __webpack_require__(132);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Categories = __webpack_require__(27);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _Error404Page = __webpack_require__(136);
	
	var _Error404Page2 = _interopRequireDefault(_Error404Page);
	
	var _Setup = __webpack_require__(147);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _Protocol = __webpack_require__(141);
	
	var _Protocol2 = _interopRequireDefault(_Protocol);
	
	var _EmbeddedApp = __webpack_require__(135);
	
	var _EmbeddedApp2 = _interopRequireDefault(_EmbeddedApp);
	
	var _ParameterizeAndDownload = __webpack_require__(140);
	
	var _ParameterizeAndDownload2 = _interopRequireDefault(_ParameterizeAndDownload);
	
	var _db = __webpack_require__(10);
	
	var _db2 = _interopRequireDefault(_db);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ProtocolView',
	  data: function data() {
	    return {
	      topHeaders: [['author', 'Author'], ['partner', 'Partner Lab'], ['description', 'Description'], ['time-estimate', 'Time Estimate'], ['modules', 'Modules']],
	      bottomHeaders: [['process', 'Process'], ['notes', 'Additional Notes']],
	      protocol: null,
	      is404: false,
	      downloadUrls: {},
	      origin: null,
	      allTabs: [],
	      currentTab: null
	    };
	  },
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    next(function (vm) {
	      if (from.name === 'category-query') {
	        vm.origin = from;
	      }
	    });
	  },
	
	  computed: {
	    categories: function categories() {
	      return [this.origin ? this.origin.params.category : null, this.origin ? this.origin.params.subCategory : null];
	    },
	    selectedOT1protocol: function selectedOT1protocol() {
	      return this.protocol && this.protocol.protocols && this.protocol.protocols['OT 1 protocol'] && this.protocol.protocols['OT 1 protocol'][0];
	    },
	    selectedOT2protocol: function selectedOT2protocol() {
	      return this.protocol && this.protocol.protocols && this.protocol.protocols['OT 2 protocol'] && this.protocol.protocols['OT 2 protocol'][0];
	    },
	    ot2DeckUrl: function ot2DeckUrl() {
	      var baseUrl = 'https://s3-us-west-2.amazonaws.com/protocol-library-kludge/production/index.html';
	      var selectedOT2protocol = this.selectedOT2protocol;
	
	      var labwareArray = selectedOT2protocol && selectedOT2protocol.labware || [];
	
	      var labware = labwareArray.reduce(function (acc, l) {
	        return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, l.slot, {
	          labwareType: l.type,
	          name: l.name
	        }));
	      }, {});
	
	      var modulesArray = selectedOT2protocol && selectedOT2protocol.modules || [];
	
	      var modules = modulesArray.reduce(function (acc, module) {
	        return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, module.slot, module.name));
	      }, {});
	
	      var encodedJson = window.encodeURI((0, _stringify2.default)({
	        labware: labware,
	        modules: modules
	      }));
	
	      return baseUrl + '?data=' + encodedJson;
	    },
	    protocolParameters: function protocolParameters() {
	      var protocolType = this.currentTab === 'ot1' ? 'OT 1 protocol' : 'OT 2 protocol';
	
	      var protocolsOfType = this.protocol && this.protocol.protocols && this.protocol.protocols[protocolType];
	
	      var numProtocolsOfType = protocolsOfType.length;
	      if (protocolsOfType && numProtocolsOfType > 1) {
	        console.warn('Got ' + numProtocolsOfType + ' protocol objects under ' + protocolType + ' key, will only show the first one');
	      }
	
	      var selectedProtocol = protocolsOfType && protocolsOfType[0];
	
	      return selectedProtocol && selectedProtocol.parameters || [];
	    },
	    getIframeSrc: function getIframeSrc() {
	      var protocol = this.protocol;
	      if (!(protocol && protocol.flags['embedded-app'])) {
	        return false;
	      }
	
	      var pattern = /\?(.*)/g;
	      var urlLocationArgs = pattern.exec(window.location.href);
	      var urlSuffix = urlLocationArgs && urlLocationArgs[1] ? '&' + urlLocationArgs[1] : '';
	
	      return protocol && protocol.flags['embedded-app'] + '?timestamp=' + Date.now() + urlSuffix;
	    },
	    tabNames: function tabNames() {
	      return { ot1: 'OT-One', ot2: 'OT-2' };
	    }
	  },
	  components: {
	    Protocol: _Protocol2.default,
	    Setup: _Setup2.default,
	    Categories: _Categories2.default,
	    Breadcrumb: _Breadcrumb2.default,
	    Error404Page: _Error404Page2.default,
	    ParameterizeAndDownload: _ParameterizeAndDownload2.default,
	    EmbeddedApp: _EmbeddedApp2.default
	  },
	  created: function created() {
	    this.fetchProtocol();
	  },
	
	  watch: {
	    '$route': 'fetchProtocol'
	  },
	  methods: {
	    fetchProtocol: function fetchProtocol() {
	      var that = this;
	      var slug = this.$route.params.slug;
	      _db2.default.getProtocol(slug).then(function (protocol) {
	        var ot1FileKey = 'OT 1 protocol';
	        var ot2FileKey = 'OT 2 protocol';
	
	        var baseDownloadUrl = 'https://d894fcc9rk.execute-api.us-west-2.amazonaws.com/ot_api_gw_prod/OpenTrons/Protocols/' + _util2.default.branchName + '/protocols/' + protocol.path.split('/')[1] + '/';
	        var toAbsPath = function toAbsPath(filePath) {
	          return baseDownloadUrl + filePath;
	        };
	        var ot1DownloadUrls = protocol.files[ot1FileKey].map(toAbsPath);
	        var ot2DownloadUrls = protocol.files[ot2FileKey].map(toAbsPath);
	
	        that.protocol = protocol;
	
	        var downloadUrls = {
	          ot1: ot1DownloadUrls[0],
	          ot2: ot2DownloadUrls[0]
	        };
	
	        var allTabs = ['ot2', 'ot1'].filter(function (robotKey) {
	          return downloadUrls[robotKey];
	        });
	
	        that.downloadUrls = downloadUrls;
	        that.allTabs = allTabs;
	        that.currentTab = allTabs ? allTabs[0] : null;
	      }, function (error) {
	        if (error.status === 404) {
	          that.is404 = true;
	        } else {
	          console.error('unhandled error fetching protocol', error);
	        }
	      });
	    },
	    navigateTab: function navigateTab(tab) {
	      this.currentTab = tab;
	    },
	    backToTop: function backToTop() {
	      window.scroll(0, 0);
	    }
	  }
	};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'RecentlyAdded'
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(11);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Categories = __webpack_require__(27);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _ProtocolPreview = __webpack_require__(142);
	
	var _ProtocolPreview2 = _interopRequireDefault(_ProtocolPreview);
	
	var _CalloutDocs = __webpack_require__(43);
	
	var _CalloutDocs2 = _interopRequireDefault(_CalloutDocs);
	
	var _mixins = __webpack_require__(9);
	
	var _db = __webpack_require__(10);
	
	var _db2 = _interopRequireDefault(_db);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ResultsView',
	  mixins: [(0, _mixins.scrubMixin)()],
	  data: function data() {
	    return {
	      category: 'N/A',
	      subcategory: 'N/A',
	      query: 'N/A',
	      protocols: []
	    };
	  },
	
	  components: {
	    Categories: _Categories2.default,
	    ProtocolPreview: _ProtocolPreview2.default,
	    CalloutDocs: _CalloutDocs2.default
	  },
	  created: function created() {
	    this.fetchProtocols();
	  },
	
	  watch: {
	    '$route': 'fetchProtocols'
	  },
	  methods: {
	    fetchProtocols: function fetchProtocols() {
	      var that = this;
	      if (this.$route.params.category) {
	        var category = this.$route.params.category;
	        var subcategory = this.$route.params.subCategory;
	        _db2.default.getProtocolsByCategory(category.replace('-', ' '), subcategory ? subcategory.replace('-', ' ') : false).then(function (protocols) {
	          that.protocols = protocols;
	        });
	      } else if (this.$route.query.q) {
	        var query = this.$route.query.q;
	        _db2.default.queryProtocols(query).then(function (response) {
	          that.protocols = response;
	        });
	      }
	    },
	    queryOriginator: function queryOriginator() {
	      var queryOrParams = (0, _keys2.default)(this.$route.params).length > 0 ? this.$route.params : { 'q': this.$route.query.q };
	      this.category = queryOrParams.category;
	      this.subcategory = queryOrParams.subCategory;
	      return queryOrParams;
	    },
	    home: function home() {
	      this.$router.push('/');
	    },
	    cat: function cat() {}
	  },
	  updated: function updated() {
	    window.scrollTo(0, 0);
	  }
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(11);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mixins = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SearchBar',
	  mixins: [(0, _mixins.scrubMixin)()],
	  data: function data() {
	    return {
	      query: '',
	      selected: 'all-categories'
	    };
	  },
	  methods: {
	    category: function category() {
	      return (0, _keys2.default)(this.$store.state.categories);
	    },
	    submitQuery: function submitQuery() {
	      this.$router.push({ name: 'search-query', query: { q: this.query } });
	    }
	  }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showdown = __webpack_require__(26);
	
	var _showdown2 = _interopRequireDefault(_showdown);
	
	var _Container = __webpack_require__(133);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Setup',
	  props: ['protocol'],
	  components: {
	    Container: _Container2.default
	  },
	  data: function data() {
	    return {
	      markdown: this.protocol.markdown,
	      containers: this.protocol.containers,
	      instruments: this.protocol.instruments,
	      rows: [1, 2, 3],
	      columns: ['A', 'B', 'C', 'D', 'E'],
	      selected: null
	    };
	  },
	
	  methods: {
	    makeHtml: function makeHtml(key) {
	      var markdownText = this.protocol.markdown ? this.protocol.markdown[key] : '';
	      return new _showdown2.default.Converter().makeHtml(markdownText);
	    },
	    occupiedSlots: function occupiedSlots() {
	      var slots = this.containers.map(function (c) {
	        return c['slot'];
	      });
	      return slots;
	    },
	    hasContainer: function hasContainer(slot) {
	      return this.occupiedSlots().includes(slot);
	    },
	    getContainer: function getContainer(slot) {
	      var container = this.containers.find(function (element) {
	        return element.slot === slot;
	      });
	      return container;
	    },
	    activateContainer: function activateContainer(slot) {
	      var activeContainer = this.getContainer(slot);
	      this.selected = activeContainer.slot;
	    },
	    deactivateContainers: function deactivateContainers() {
	      this.selected = null;
	    },
	    isActive: function isActive(slot) {
	      return slot === this.selected;
	    },
	    axis: function axis(_axis) {
	      if (_axis === 'a') {
	        return 'center';
	      } else {
	        return 'left';
	      }
	    }
	  }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SiteFooter'
	};

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ot2-animation.7a79452.gif";

/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(117)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(162),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(156),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(115)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(152),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(118)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(166),
	  /* scopeId */
	  "data-v-e34b1424",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(54),
	  /* template */
	  __webpack_require__(161),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(119)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(55),
	  /* template */
	  __webpack_require__(167),
	  /* scopeId */
	  "data-v-f12b3ebe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(56),
	  /* template */
	  __webpack_require__(164),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(57),
	  /* template */
	  __webpack_require__(165),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(116)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(58),
	  /* template */
	  __webpack_require__(154),
	  /* scopeId */
	  "data-v-40aa51d6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(59),
	  /* template */
	  __webpack_require__(150),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(60),
	  /* template */
	  __webpack_require__(149),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(61),
	  /* template */
	  __webpack_require__(163),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(114)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(62),
	  /* template */
	  __webpack_require__(151),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(63),
	  /* template */
	  __webpack_require__(157),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(64),
	  /* template */
	  __webpack_require__(160),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(65),
	  /* template */
	  __webpack_require__(153),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(66),
	  /* template */
	  __webpack_require__(155),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(120)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(67),
	  /* template */
	  __webpack_require__(168),
	  /* scopeId */
	  "data-v-f1e31ef8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-page"
	  }, _vm._l((_vm.content), function(item) {
	    return _c('div', {
	      attrs: {
	        "id": item.key
	      }
	    }, [(_vm.hasContent(item)) ? _c('h3', {
	      attrs: {
	        "id": item.key + '-header'
	      }
	    }, [_vm._v("\n      " + _vm._s(item.header) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      attrs: {
	        "id": item.key + '-content'
	      },
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    })])
	  }))
	},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "download-parametric"
	  }, [_c('div', {
	    attrs: {
	      "id": "download-protocol-pseudoform"
	    }
	  }, [_vm._l((_vm.protocolFields), function(param) {
	    return (param.isFile) ? _c('div', [_c('label', [_vm._v(_vm._s(param.name && param.name.replace(/_/g, ' ')))]), _vm._v(" "), _c('input', {
	      attrs: {
	        "name": "",
	        "type": "file",
	        "value": ""
	      },
	      on: {
	        "change": function($event) {
	          _vm.updateFile($event, param.name)
	        }
	      }
	    }), _vm._v(" "), (param.htmlElem === 'select') ? _c('select', {
	      attrs: {
	        "name": param.name
	      }
	    }, _vm._l((param.options), function(opt) {
	      return _c('option', {
	        domProps: {
	          "value": opt.value,
	          "selected": opt.value === opt.default
	        }
	      }, [_vm._v(_vm._s(opt.text))])
	    })) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "download-protocol-form",
	      "action": _vm.fullDownloadUrl,
	      "method": "GET",
	      "enctype": "application/x-www-form-urlencoded"
	    }
	  }, [_vm._l((_vm.protocolFields), function(param) {
	    return (!param.isFile) ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(param.name && param.name.replace(/_/g, ' ')) + "\n        ")]), _vm._v(" "), (param.htmlElem === 'input' && !param.isFile) ? _c('input', {
	      attrs: {
	        "name": param.name,
	        "type": param.type,
	        "step": param.step
	      },
	      domProps: {
	        "value": param.default
	      }
	    }) : _vm._e(), _vm._v(" "), (param.htmlElem === 'select') ? _c('select', {
	      attrs: {
	        "name": param.name
	      }
	    }, _vm._l((param.options), function(opt) {
	      return _c('option', {
	        domProps: {
	          "value": opt.value,
	          "selected": opt.value === opt.default
	        }
	      }, [_vm._v(_vm._s(opt.text))])
	    })) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.files), function(fileString, filename) {
	    return _c('div', [_c('input', {
	      attrs: {
	        "name": filename,
	        "type": "hidden"
	      },
	      domProps: {
	        "value": fileString
	      }
	    })])
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "name": "fields",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": _vm.specialFieldsKey
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "id": "download-protocol",
	      "data-gtm-action": _vm.subdomain,
	      "data-gtm-category": "Protocol-Download",
	      "data-gtm-label": _vm.protocolSlug
	    },
	    domProps: {
	      "value": 'Download For ' + _vm.robotTab
	    }
	  })], 2)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [(_vm.protocol) ? _c('Breadcrumb', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "categories": _vm.categories
	    }
	  }) : _vm._e(), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "protocol"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('Categories')], 1), _vm._v(" "), _c('section', {
	    staticClass: "results protocol"
	  }, [(_vm.protocol) ? _c('div', {
	    attrs: {
	      "id": "title-block"
	    }
	  }, [_c('div', {
	    staticClass: "protocol-title"
	  }, [_c('h1', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v(_vm._s(_vm.protocol.title))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "selected-protocol"
	  }, [(_vm.is404) ? _c('Error404Page') : _vm._e(), _vm._v(" "), (_vm.protocol) ? _c('span', [_c('Protocol', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "headers": _vm.topHeaders
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "robot-tab"
	  }, [_vm._l((_vm.allTabs), function(tab) {
	    return (_vm.downloadUrls[tab]) ? _c('span', {
	      class: {
	        selected: (tab === _vm.currentTab)
	      },
	      on: {
	        "click": function($event) {
	          _vm.navigateTab(tab)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(_vm.tabNames[tab]) + "\n            ")]) : _vm._e()
	  }), _vm._v(" "), _c('span', {
	    staticClass: "filler"
	  })], 2), _vm._v(" "), _c('h2', {
	    staticClass: "download-protocol-header"
	  }, [_vm._v("Download Protocol:")]), _vm._v(" "), (_vm.protocol.flags['embedded-app'] === false && _vm.downloadUrls[_vm.currentTab]) ? _c('ParameterizeAndDownload', {
	    attrs: {
	      "downloadUrl": _vm.downloadUrls[_vm.currentTab],
	      "protocolSlug": _vm.protocol.slug,
	      "robotTab": _vm.tabNames[_vm.currentTab],
	      "protocolParameters": _vm.protocolParameters
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'ot1') ? _c('Setup', {
	    attrs: {
	      "protocol": _vm.selectedOT1protocol
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "ot2_deck_map_wrapper"
	  }, [_c('div', {
	    staticClass: "ot2_deck_map"
	  }, [(_vm.currentTab === 'ot2') ? _c('iframe', {
	    attrs: {
	      "src": _vm.ot2DeckUrl
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('Protocol', {
	    attrs: {
	      "protocol": _vm.protocol,
	      "headers": _vm.bottomHeaders
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.getIframeSrc) ? _c('EmbeddedApp', {
	    attrs: {
	      "src": _vm.getIframeSrc
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.protocol) ? _c('button', {
	    staticClass: "back-to-top",
	    on: {
	      "click": _vm.backToTop
	    }
	  }, [_vm._v("\n        BACK TO TOP\n      ")]) : _vm._e()])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "placeable",
	    on: {
	      "mouseover": function($event) {
	        _vm.show = true
	      },
	      "mouseout": function($event) {
	        _vm.show = false
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.containerImg()
	    },
	    on: {
	      "error": _vm.addDefaultSrc
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show) ? _c('span', {
	    staticClass: "tooltip"
	  }, [_vm._v(" \n    " + _vm._s(_vm.placeable.name) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.placeable.slot) + "\n    ")]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search"
	  }, [_c('div', {
	    attrs: {
	      "id": "protocol-search"
	    }
	  }, [_c('span', {
	    staticClass: "search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query),
	      expression: "query"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "protocol-search",
	      "placeholder": "Search For Protocols"
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.submitQuery()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "disabled": _vm.query == ''
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitQuery()
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    attrs: {
	      "id": "nav"
	    }
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('nav', {
	    staticClass: "navbar"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "navbar-container"
	  }, [_c('div', {
	    staticClass: "navbar-logo",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(1, false, false)]), _vm._v(" "), _c('div', {
	    staticClass: "schedule-menu mobile-schedule-menu"
	  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
	    staticClass: "mobile-hamburger",
	    class: {
	      open: _vm.open
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "nav-collapse"
	    },
	    on: {
	      "click": _vm.toggleOpen
	    }
	  }, [_c('div', {
	    staticClass: "bar1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bar2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bar3"
	  })])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "click-outside",
	      rawName: "v-click-outside",
	      value: (_vm.closeOutside),
	      expression: "closeOutside"
	    }],
	    staticClass: "navbar-menu"
	  }, [_c('ul', {
	    staticClass: "main-menu"
	  }, [_c('li', {
	    staticClass: "main-menu-li about",
	    on: {
	      "click": function($event) {
	        _vm.toggleMenu("about"), _vm.isActive("about")
	      }
	    }
	  }, [_c('span', {
	    staticClass: "menu-span",
	    class: {
	      notActive: _vm.active.about
	    }
	  }, [_vm._v("About")]), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-ul",
	    class: {
	      visible: !_vm.nav.about
	    },
	    attrs: {
	      "id": "about"
	    }
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/about",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "about",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Mission")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/team",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "team",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Our Team")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://blog.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "blog",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Blog")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "main-menu-li",
	    on: {
	      "click": function($event) {
	        _vm.toggleMenu("products"), _vm.isActive("products")
	      }
	    }
	  }, [_c('span', {
	    staticClass: "menu-span",
	    class: {
	      notActive: _vm.active.products
	    }
	  }, [_vm._v("Products")]), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-ul",
	    class: {
	      visible: !_vm.nav.products
	    },
	    attrs: {
	      "id": "products"
	    }
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-2",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-2",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Robot")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tempmod",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Temp Module")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules#magnetic_module",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "magmod",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Magnetic Module")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pipettes",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-2-pipettes",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Pipettes")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/opentrons-tips",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tips",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Pipette Tips")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/racks-and-adapters",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tube-racks",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Racks & Adapters")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/mag-bead-kits",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "reagents",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Reagents")])]), _vm._v(" "), _c('a', {
	    staticClass: "blue blue-products",
	    attrs: {
	      "href": "https://shop.opentrons.com",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "all-products",
	      "data-gtm-action": "click"
	    },
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_vm._v("Shop all products ›")])])]), _vm._v(" "), _c('li', {
	    staticClass: "main-menu-li",
	    on: {
	      "click": function($event) {
	        _vm.toggleMenu("applications"), _vm.isActive("applications")
	      }
	    }
	  }, [_c('span', {
	    staticClass: "menu-span",
	    class: {
	      notActive: _vm.active.applications
	    }
	  }, [_vm._v("Applications")]), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-ul",
	    class: {
	      visible: !_vm.nav.applications
	    },
	    attrs: {
	      "id": "applications"
	    }
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pcr-sample-prep",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "prep",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("PCR Sample Prep")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/nucleic-acid-cleanup",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "nac",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Nucleic Acid Cleanup")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/Sample%20Prep/PCR",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "qpcr",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("qPCR/RT-PCR")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "elisa",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("ELISA")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/NGS%20Library%20Prep",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ngs-prep",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("NGS Library Prep")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/Basic%20Pipetting",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "basic",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Basic Pipetting")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "main-menu-li",
	    on: {
	      "click": function($event) {
	        _vm.toggleMenu("protocols"), _vm.isActive("protocols")
	      }
	    }
	  }, [_c('span', {
	    staticClass: "menu-span",
	    class: {
	      notActive: _vm.active.protocols
	    }
	  }, [_vm._v("Protocols")]), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-ul protocol-nav",
	    class: {
	      visible: !_vm.nav.protocols
	    },
	    attrs: {
	      "id": "protocols"
	    }
	  }, [_c('div', {
	    staticClass: "navbar-ul-div"
	  }, [_c('div', {
	    staticClass: "protocol-items"
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/protocols",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-tools",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Options")]), _vm._v(" "), _c('span', [_vm._v("Gain an overview of our protocol creation options")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/protocols/designer",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-designer",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Designer")]), _vm._v(" "), _c('span', [_vm._v("Use our graphical user interface to design protocols")])]), _vm._v(" "), _c('li', {
	    staticClass: "protocol-bottom",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Library")]), _vm._v(" "), _c('span', [_vm._v("Explore our open source database of protocols")])])]), _vm._v(" "), _c('div', {
	    staticClass: "protocol-items"
	  }, [_c('li', {
	    staticClass: "protocol-items-li",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://docs.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "opentrons-api",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Python API")]), _vm._v(" "), _c('span', {
	    staticClass: "protocol-items-span"
	  }, [_vm._v("\n                      Maximum customization for anyone with python and basic\n                      wetlab skills\n                    ")])]), _vm._v(" "), _c('li', {
	    staticClass: "protocol-items-li",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://github.com/Opentrons",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "github-protocols",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Github")]), _vm._v(" "), _c('span', {
	    staticClass: "protocol-items-span"
	  }, [_vm._v("Contribute to open source protocol repository")])])])]), _vm._v(" "), _c('div', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    staticClass: "blue",
	    attrs: {
	      "href": "https://opentrons.com/request-protocol",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "request-protocol-protocols",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Request a free custom protocol ›")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "main-menu-li",
	    on: {
	      "click": function($event) {
	        _vm.toggleMenu("sns"), _vm.isActive("sns")
	      }
	    }
	  }, [_c('span', {
	    staticClass: "menu-span",
	    class: {
	      notActive: _vm.active.sns
	    }
	  }, [_vm._v("Support & Sales")]), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-ul protocol-nav sns",
	    class: {
	      visible: !_vm.nav.sns
	    },
	    attrs: {
	      "id": "sns"
	    }
	  }, [_c('div', {
	    staticClass: "navbar-ul-li"
	  }, [_c('div', {
	    staticClass: "protocol-items"
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('span', {
	    staticClass: "support-sales"
	  }, [_vm._v("SUPPORT")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://support.opentrons.com/guide-for-getting-started-with-the-ot-2",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "start-guide",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Start Guide")]), _vm._v(" "), _c('span', [_vm._v("You received your robot, here's what's next")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://support.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "product-help",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Product Help")]), _vm._v(" "), _c('span', [_vm._v("Answer common technical questions")])]), _vm._v(" "), _c('li', {
	    staticClass: "github",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://github.com/Opentrons",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "github-support",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Github")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-ul-li"
	  }, [_c('div', {
	    staticClass: "protocol-items"
	  }, [_c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('span', {
	    staticClass: "support-sales"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://labware.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "labware-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Labware Library")]), _vm._v(" "), _c('span', [_vm._v("\n                      Understand what labware is compatible with the\n                      OT-2\n                    ")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('span', {
	    staticClass: "support-sales"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "return_policy",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Warranty & Returns")]), _vm._v(" "), _c('span', [_vm._v("\n                      100% risk free returns and a quality-backed\n                      warranty\n                    ")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-app",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-app",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Install the app")])]), _vm._v(" "), _c('a', {
	    staticClass: "blue-text",
	    attrs: {
	      "href": "https://opentrons.com/contact-support",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-support",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact support ›")])])]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-ul-li order-online"
	  }, [_c('div', {
	    staticClass: "protocol-items"
	  }, [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "support-sales"
	  }, [_vm._v("SALES")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://shop.opentrons.com",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "shop",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Order online")])]), _vm._v(" "), _c('a', {
	    staticClass: "blue-text",
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://opentrons.com/contact",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-sales",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact sales ›")])]), _vm._v(" "), _c('a', {
	    staticClass: "btn schedule-demo",
	    attrs: {
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "cta-demo-button",
	      "data-gtm-action": "click",
	      "href": "https://opentrons.com/demo",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Schedule a demo ›")])])])])]), _vm._v(" "), _vm._m(3, false, false)]), _vm._v(" "), _c('div', {
	    staticClass: "div-sub-menu"
	  }, [_c('div', {
	    staticClass: "mobile-menu",
	    class: {
	      mobilemenufixed: _vm.menu, dnone: !_vm.open
	    }
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showMenu('about')
	      }
	    }
	  }, [_vm._v("About")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showMenu('products')
	      }
	    }
	  }, [_vm._v("Products")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showMenu('applications')
	      }
	    }
	  }, [_vm._v("Applications")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showMenu('protocols')
	      }
	    }
	  }, [_vm._v("Protocols")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.showMenu('sns')
	      }
	    }
	  }, [_vm._v("Support & Sales")])]), _vm._v(" "), _c('div', {
	    staticClass: "menu-button",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "https://opentrons.com/contact",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-sales-primary",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact Sales")])])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-menu about",
	    class: {
	      showmenu: _vm.mobileNav.about, dnone: !_vm.open
	    }
	  }, [_c('div', {
	    staticClass: "sub-menu-div",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(8),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("About")])]), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/about",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "about",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Mission ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/team",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "team",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Our Team ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://blog.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "blog",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Blog ›")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-menu products",
	    class: {
	      showmenu: _vm.mobileNav.products, dnone: !_vm.open
	    }
	  }, [_c('div', {
	    staticClass: "sub-menu-div",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(8),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Products")])]), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-2",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-2",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Robot ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tempmod",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Temp Module")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "magmod",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Magnetic Module ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pipettes",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-2-pipettes",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Pipettes ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/opentrons-tips",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tips",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Pipette Tips ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/racks-and-adapters",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "tube-racks",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Racks & Adapters ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://shop.opentrons.com/collections/mag-bead-kits",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "reagents",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Reagents ›")])]), _vm._v(" "), _c('li', {
	    staticClass: "blue",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    staticClass: "blue",
	    attrs: {
	      "href": "https://shop.opentrons.com",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "all-products",
	      "data-gtm-action": "click"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Shop all products ›")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-menu applications",
	    class: {
	      showmenu: _vm.mobileNav.applications, dnone: !_vm.open
	    }
	  }, [_c('div', {
	    staticClass: "sub-menu-div",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(8),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Applications")])]), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pcr-sample-prep",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "prep",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("PCR Sample Prep ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/nucleic-acid-cleanup",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "nac",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Nucleic Acid Cleanup")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/Sample%20Prep/PCR",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "qpcr",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("qPCR/RT-PCR ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "elisa",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("ELISA ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/NGS%20Library%20Prep",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ngs-prep",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("NGS Library Prep ›")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com/categories/Basic%20Pipetting",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "basic",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Basic Pipetting ›")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-menu protocols",
	    class: {
	      showmenu: _vm.mobileNav.protocols, dnone: !_vm.open
	    }
	  }, [_c('div', {
	    staticClass: "sub-menu-div",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(8),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Protocols")])]), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/protocols",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-tools",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Options ›")]), _vm._v(" "), _c('span', [_vm._v("Gain an overview of our protocol creation options")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/protocols/designer",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-designer",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Designer ›")]), _vm._v(" "), _c('span', [_vm._v("Use our graphical user interface to design protocols")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://protocols.opentrons.com",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "protocol-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Library ›")]), _vm._v(" "), _c('span', [_vm._v("Explore our open source database of protocols")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://docs.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "opentrons-api",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Python API ›")]), _vm._v(" "), _c('span', [_vm._v("\n                Maximum customization for anyone with python and basic weblab\n                skills\n              ")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://github.com/Opentrons",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "github-protocols",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Github ›")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('a', {
	    staticClass: "blue",
	    attrs: {
	      "href": "https://opentrons.com/request-protocol",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "request-protocol-protocols",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Request a free custom protocol ›")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-menu sns",
	    class: {
	      showmenu: _vm.mobileNav.sns, dnone: !_vm.open
	    }
	  }, [_c('div', {
	    staticClass: "sub-menu-div",
	    on: {
	      "click": _vm.closeMenu
	    }
	  }, [_vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)]), _vm._v(" "), _c('ul', {
	    staticClass: "sns-ul"
	  }, [_c('section', {
	    staticClass: "sns-sales"
	  }, [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(6, false, false)]), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(7, false, false)]), _vm._v(" "), _vm._m(8, false, false)]), _vm._v(" "), _c('section', {
	    staticClass: "sns-support"
	  }, [_c('li', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(9, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(10, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(11, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(12, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(13, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(14, false, false)]), _vm._v(" "), _c('li', {
	    staticClass: "sns-support-li",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._m(15, false, false)])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "docs-navbar"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "container-div"
	  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://docs.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-toolbar",
	      "data-gtm-label": "opentrons-api",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Python API")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://labware.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-toolbar",
	      "data-gtm-label": "labware-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Labware Library")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-toolbar",
	      "data-gtm-label": "protocol-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Library")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://designer.opentrons.com/",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-toolbar",
	      "data-gtm-label": "protocol-designer",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Protocol Designer")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "brand",
	    attrs: {
	      "href": "https://opentrons.com/",
	      "title": "Home",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "logo",
	      "data-gtm-action": "click"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png",
	      "alt": "Opentrons Home"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "schedule-div"
	  }, [_c('a', {
	    staticClass: "btn schedule-demo",
	    attrs: {
	      "href": "https://opentrons.com/contact",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-sales",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact sales")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "schedule-menu desktop-schedule-menu"
	  }, [_c('div', {
	    staticClass: "schedule-div"
	  }, [_c('a', {
	    staticClass: "btn schedule-demo",
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://opentrons.com/contact",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-sales-primary",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact Sales")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sns-arrow"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(8),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sns-span"
	  }, [_c('span', [_vm._v("Support & Sales")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }, [_vm._v("SALES")]), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    staticClass: "order-line-mobile",
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://shop.opentrons.com",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "shop",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Order online ›")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section"
	  }, [_c('span', {
	    staticClass: "sales-tron mobile-contact"
	  }), _vm._v(" "), _c('div', [_c('a', {
	    staticClass: "sales-link mobile-contact-sales",
	    attrs: {
	      "href": "https://opentrons.com/contact",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-sales",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact sales ›")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('section', {
	    staticClass: "sns-support-section"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', [_c('a', {
	    staticClass: "sales-link schedule-demo-mobile",
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "schedule-demo",
	      "data-gtm-action": "click",
	      "href": "https://opentrons.com/demo"
	    }
	  }, [_vm._v("Schedule a demo ›")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }, [_vm._v("SUPPORT")]), _vm._v(" "), _c('div', {
	    staticClass: "ot-2-start-guide support-items"
	  }, [_c('a', {
	    staticClass: "ot-2-guide",
	    attrs: {
	      "href": "https://support.opentrons.com/guide-for-getting-started-with-the-ot-2",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "start-guide",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("OT-2 Start Guide ›")]), _vm._v(" "), _c('span', {
	    staticClass: "ot-2-guide"
	  }, [_vm._v("You received your robot, here's what's next")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://support.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "product-help",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Product Help ›")]), _vm._v(" "), _c('span', [_vm._v("Answer common technical questions")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://github.com/Opentrons",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "github-support",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Github ›")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://labware.opentrons.com/",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "labware-library",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Labware Library ›")]), _vm._v(" "), _c('span', [_vm._v("\n                      Understand what labware is compatible with the\n                      OT-2\n                    ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "return_policy",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Warranty & Returns ›")]), _vm._v(" "), _c('span', [_vm._v("100% risk free returns and a quality-backed warranty")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "support-items"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-app",
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "ot-app",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Install the app ›")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sns-support-section ot-2"
	  }, [_c('span', {
	    staticClass: "sales-tron"
	  }), _vm._v(" "), _c('div', [_c('a', {
	    staticClass: "blue-text sales-link",
	    attrs: {
	      "target": "_blank",
	      "rel": "noopener noreferrer",
	      "href": "https://opentrons.com/contact-support",
	      "data-gtm-category": "p-header",
	      "data-gtm-label": "contact-support",
	      "data-gtm-action": "click"
	    }
	  }, [_vm._v("Contact support ›")])])])
	}]}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "protocol-setup"
	    }
	  }, [_c('h2', {
	    staticClass: "offset",
	    attrs: {
	      "id": "setup"
	    }
	  }, [_vm._v("Setup")]), _vm._v(" "), _c('div', {
	    staticClass: "setup"
	  }, [_c('div', {
	    attrs: {
	      "id": "deck-list"
	    }
	  }, [_c('h3', [_vm._v("Deck Map")]), _vm._v(" "), _c('h4', [_vm._v("Containers")]), _vm._v(" "), _c('ul', {
	    staticClass: "containers"
	  }, _vm._l((_vm.containers), function(container) {
	    return _c('li', [_vm._v("\n    ["), _c('a', {
	      on: {
	        "mouseenter": function($event) {
	          _vm.activateContainer(container.slot)
	        },
	        "mouseout": function($event) {
	          _vm.deactivateContainers()
	        }
	      }
	    }, [_vm._v(_vm._s(container.slot))]), _vm._v("] " + _vm._s(container.name) + " (" + _vm._s(container.type) + ")\n    ")])
	  })), _vm._v(" "), _c('h4', [_vm._v("Pipettes")]), _vm._v(" "), _c('ul', {
	    staticClass: "instruments"
	  }, _vm._l((_vm.instruments), function(instrument) {
	    return _c('li', [_vm._v("\n        " + _vm._s(instrument.name) + " " + _vm._s(instrument.type) + " (" + _vm._s(_vm.axis(instrument.axis)) + ")\n      ")])
	  })), _vm._v(" "), _c('h3', {
	    attrs: {
	      "id": "reagents"
	    }
	  }, [_vm._v("Reagents")]), _vm._v(" "), _c('div', {
	    staticClass: "reagents",
	    domProps: {
	      "innerHTML": _vm._s(_vm.makeHtml('reagents'))
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "deck-map"
	    }
	  }, [_c('div', {
	    staticClass: "deck"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.columns), function(col) {
	    return _c('div', {
	      staticClass: "deck-col"
	    }, _vm._l((_vm.rows), function(row) {
	      return _c('div', {
	        staticClass: "deck-slot",
	        class: {
	          occupied: _vm.hasContainer(col + row)
	        },
	        attrs: {
	          "id": col + row
	        }
	      }, [(_vm.hasContainer(col + row)) ? _c('Container', {
	        class: {
	          active: _vm.isActive(col + row)
	        },
	        attrs: {
	          "placeable": _vm.getContainer(col + row)
	        }
	      }) : _c('div', {
	        staticClass: "empty"
	      }, [_c('p', [_vm._v(_vm._s(col + row))])])], 1)
	    }))
	  }))])])])])
	},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "breadcrumb"
	  }, [_c('ul', [_vm._l((_vm.links), function(link) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": link.url
	      }
	    }, [_vm._v(_vm._s(link.name))])], 1)
	  }), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.protocol.title))])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "recently-added"
	  }, [_c('h2', [_vm._v("Recently Added")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Parametric PCR")]), _vm._v(" "), _c('p', [_vm._v("Author "), _c('a', [_vm._v("Opentrons")])]), _vm._v(" "), _c('p', [_vm._v("Ut sollicitudin viverra volutpat. Pellentesque aliquam hendrerit tempor. Sed ut leo interdum, porttitor nunc a.")]), _vm._v(" "), _c('a', {
	    staticClass: "view-protocol"
	  }, [_vm._v("View Protocol")])])])
	}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "categories"
	  }, _vm._l((_vm.categories()), function(category) {
	    return _c('div', [_c('h3', [_c('router-link', {
	      staticClass: "category",
	      attrs: {
	        "to": ("/categories/" + (_vm.scrub(category))),
	        "active-class": "active",
	        "exact": ""
	      }
	    }, [_c('a', [_vm._v(_vm._s(category))])])], 1), _vm._v(" "), _vm._l((_vm.subCategories(category)), function(subCategory) {
	      return _c('h4', {
	        staticClass: "subcategories"
	      }, [_c('router-link', {
	        staticClass: "subCategory",
	        attrs: {
	          "to": ("/categories/" + (_vm.scrub(category)) + "/" + (_vm.scrub(subCategory))),
	          "active-class": "active",
	          "exact": ""
	        }
	      }, [_vm._v("\n        " + _vm._s(subCategory) + "\n      ")])], 1)
	    })], 2)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "custom-call-to-action"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Can’t find what you’re looking for?")]), _c('br'), _vm._v("\n    Let us help you with a "), _c('a', {
	    on: {
	      "click": _vm.openChat
	    }
	  }, [_vm._v("custom protocol.")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('h2', [_vm._v("Custom"), _c('br'), _vm._v("Protocol")])])
	}]}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('nav', {
	    staticClass: "breadcrumb",
	    attrs: {
	      "id": "results-nav"
	    }
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": '/'
	    }
	  }, [_vm._v("Protocol Library")])], 1), _vm._v(" "), (_vm.category) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": ("/categories/" + (_vm.scrub(_vm.category)))
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.category) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.subcategory) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": ("/categories/" + (_vm.scrub(_vm.category)) + "/" + (_vm.scrub(_vm.subcategory)))
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.subcategory) + "\n          ")])], 1) : _vm._e()])]), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "category"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('h2', {
	    on: {
	      "click": function($event) {
	        _vm.home()
	      }
	    }
	  }, [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
	    staticClass: "results"
	  }, [_c('div', {
	    staticClass: "selected-category"
	  }, [_c('h4', [_vm._v("Results For:\n        "), _vm._l((_vm.queryOriginator()), function(value, key) {
	    return (value != null) ? _c('span', {
	      staticClass: "query"
	    }, [_vm._v("\n        \"" + _vm._s(value) + "\" \n        ")]) : _vm._e()
	  })], 2), _vm._v(" "), _vm._l((_vm.protocols), function(protocol) {
	    return _c('ProtocolPreview', {
	      attrs: {
	        "protocol": protocol
	      }
	    })
	  }), _vm._v(" "), (_vm.protocols.length === 0) ? _c('span', [_vm._v("\n           Don't see the protocol you need? We'll make it for you! Schedule a demo or chat with our Science team "), _c('a', {
	    attrs: {
	      "id": "intercom-chat",
	      "href": "#",
	      "onclick": "window.Intercom('show');",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Intercom",
	      "data-gtm-label": "click"
	    }
	  }, [_vm._v("here")]), _vm._v(".\n           ")]) : _vm._e()], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('iframe', {
	    attrs: {
	      "src": _vm.src,
	      "id": "embedded-app"
	    }
	  }, [_c('p', [_vm._v("Your browser does not support iframes. Please enable iframes or try using a modern browser")])])
	},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('navigation'), _vm._v(" "), _c('SearchBar'), _vm._v(" "), _c('DeprecationBanner'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('SiteFooter')], 1)
	},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-results"
	  }, [_c('div', {
	    staticClass: "protocol",
	    attrs: {
	      "id": _vm.protocol._id
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.link,
	      "tag": "h2"
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.info(_vm.protocol, "title")))])]), _vm._v(" "), (_vm.info(_vm.protocol, 'time-estimate')) ? _c('div', {
	    attrs: {
	      "id": "time"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'time-estimate')))])]) : _vm._e(), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "author"
	    }
	  }, [_c('span', [_vm._v("Author: " + _vm._s(_vm.info(_vm.protocol, "author")) + " ")]), _vm._v(" "), (_vm.info(_vm.protocol, 'partner')) ? _c('span', [_vm._v("| Partner: " + _vm._s(_vm.info(_vm.protocol, "partner")) + " ")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'description')))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "featured-protocol"
	  }, [_c('div', {
	    staticClass: "protocol"
	  }, [_c('h2', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'protocol',
	        params: {
	          slug: _vm.protocol._source.slug
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.protocol._source.title))])], 1), _vm._v(" "), (_vm.info('time-estimate')) ? _c('div', {
	    attrs: {
	      "id": "time"
	    }
	  }, [_vm._v(_vm._s(_vm.info('time-estimate')))]) : _vm._e(), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "author"
	    }
	  }, [_vm._v("Author: " + _vm._s(_vm.protocol._source.author) + "\n      "), (_vm.hasContent('partner')) ? _c('span', {
	    attrs: {
	      "id": "partner"
	    }
	  }, [_vm._v(" | Partner: " + _vm._s(_vm.protocol._source.partner))]) : _vm._e()]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "preview"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.makeHtml(_vm.protocol._source.markdown.preview))
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "landing"
	    }
	  }, [_c('aside', {
	    staticClass: "refine"
	  }, [_c('h2', [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
	    staticClass: "landing"
	  }, [(_vm.featuredProtocols.length > 0) ? _c('h2', {
	    attrs: {
	      "id": "featured"
	    }
	  }, [_vm._v("Featured Protocols")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.featuredProtocols), function(protocol) {
	    return _c('FeaturedProtocol', {
	      attrs: {
	        "protocol": protocol
	      }
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "deprecation-banner"
	  }, [_c('img', {
	    staticClass: "lightbulb",
	    attrs: {
	      "src": __webpack_require__(128)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('h3', {
	    staticClass: "header"
	  }, [_vm._v("We thought you'd like to know...")]), _vm._v(" "), _c('p', {
	    staticClass: "content-copy"
	  }, [_vm._v("\n      You are currently viewing the Opentrons APIv1 Protocol Library. We've recently released\n      "), _c('a', {
	    attrs: {
	      "href": "https://docs.opentrons.com",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Opentrons APIv2")]), _vm._v(", and as such the APIv1 library\n      will no longer be updated.\n      "), _c('b', [_vm._v("Opentrons App and Robot Software version 4.0.0 and later will no longer support APIv1.")]), _vm._v("\n      Please visit the new\n      "), _c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Opentrons APIv2 Protocol Library")]), _vm._v("\n      to access the most up-to-date protocols.\n    ")])])])
	}]}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "error404"
	  }, [_c('img', {
	    staticClass: "ot2_animation",
	    attrs: {
	      "src": __webpack_require__(129)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('h2', [_vm._v("Sorry!")]), _vm._v(" "), _c('span', [_vm._v("Protocol not found.")])])])
	}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('section', {
	    staticClass: "social-signup"
	  }, [_c('div', {
	    staticClass: "social-links"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/OpenTrons-Labworks/",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Facebook"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_facebook.png",
	      "alt": "facebook logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://twitter.com/OpenTrons_",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Twitter"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_twitter.png",
	      "alt": "twitter logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/opentronslab/",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Instagram"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_instagram.png",
	      "alt": "instagram logo"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCvMRmXIxnHs3AutkVhuqaQg",
	      "target": "_blank",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Social",
	      "data-gtm-label": "Open Youtube"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_youtube.png",
	      "alt": "youtube logo"
	    }
	  })])]), _vm._v(" "), _c('h3', [_vm._v("Sign Up For Our Newsletter")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "mc_embed_signup"
	    }
	  }, [_c('form', {
	    staticClass: "validate",
	    attrs: {
	      "action": "//opentrons.us8.list-manage.com/subscribe/post?u=000595683fb96c5fb3c54cf53&id=ba66060a9c",
	      "method": "post",
	      "id": "mc-embedded-subscribe-form",
	      "name": "mc-embedded-subscribe-form",
	      "target": "_blank",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "mc_embed_signup_scroll"
	    }
	  }, [_c('input', {
	    staticClass: "email-newsletter",
	    attrs: {
	      "type": "email",
	      "value": "",
	      "name": "EMAIL",
	      "id": "mce-EMAIL",
	      "placeholder": "email address",
	      "required": "",
	      "data-gtm-action": "input",
	      "data-gtm-category": "Mailchimp",
	      "data-gtm-label": "Enter Email"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "absolute",
	      "left": "-5000px"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "name": "b_000595683fb96c5fb3c54cf53_ba66060a9c",
	      "tabindex": "-1",
	      "value": ""
	    }
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "gray subscribe",
	    attrs: {
	      "type": "submit",
	      "value": "Subscribe",
	      "name": "subscribe",
	      "id": "mc-embedded-subscribe",
	      "data-gtm-action": "click",
	      "data-gtm-category": "Mailchimp",
	      "data-gtm-label": "Newsletter Signup"
	    }
	  })])])]), _vm._v(" "), _c('p', {
	    staticClass: "copyrite"
	  }, [_vm._v("© OPENTRONS 2017")])]), _vm._v(" "), _c('section', {
	    staticClass: "footer-menu"
	  }, [_c('ul', [_c('li', [_vm._v("Products")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/robots"
	    }
	  }, [_vm._v("OT-One")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-2"
	    }
	  }, [_vm._v("OT-2")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/pipettes"
	    }
	  }, [_vm._v("Pipettes")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/modules"
	    }
	  }, [_vm._v("Modules")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/ot-app"
	    }
	  }, [_vm._v("OT App")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://protocols.opentrons.com/"
	    }
	  }, [_vm._v("Protocol Library")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Company")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/about"
	    }
	  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/team"
	    }
	  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://blog.opentrons.com/"
	    }
	  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://opentrons.com/contact"
	    }
	  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "hiring",
	    attrs: {
	      "href": "https://opentrons.com/jobs",
	      "target": "_blank"
	    }
	  }, [_vm._v("WE'RE HIRING")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Resources")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://support.opentrons.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Support")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://support.opentrons.com/getting-started",
	      "target": "_blank"
	    }
	  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://docs.opentrons.com/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Opentrons API")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/Opentrons/opentrons",
	      "target": "_blank"
	    }
	  }, [_vm._v("Open Source")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    staticClass: "buy",
	    attrs: {
	      "href": "https://shop.opentrons.com/"
	    }
	  }, [_vm._v("Buy")])])])])])])
	}]}

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.dd706d6f8a1c117b8a0d.js